import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import router from "@/router";
import Axios, { AxiosResponse, AxiosInstance } from "axios";
import {
  LockGroupsApi,
  LocksApi,
  LockLogsApi,
  CreateSessionParam,
  AuthenticationApi,
  CreateSessionResult,
  LockGroup,
  Lock,
  SetLockgroupParam,
  GetLockLogsResult,
  PersonsApi,
  Person,
  InsertPersonParam,
  InsertResult,
  PersonInsert,
  KeysApi,
  Key,
  ZonesApi,
  Zone,
} from "@/../generated/iloq-api";



@Module({ dynamic: true, store, name: "LocksModule" })
export default class LockStore extends VuexModule {
  errorMessage: string | null = null;
  axiosInstance: AxiosInstance | null = null;
  apiAddress = "https://s10.iloq.com/iloqpool2wss65";
  sessionId = "";
  lockGroupId = "";
  locks: Lock[] = [];
  persons: Person[] = [];
  keys: Key[] = [];
  zones: Zone[] = [];

  get headerConfig() {
    return { headers: { SessionID: this.sessionId } };
  }

  @Mutation
  initialize() {
    this.sessionId = localStorage.getItem("sessionId") ?? "";
    this.axiosInstance = Axios.create();
    console.log('ds------------');
    
    // this.axiosInstance.interceptors.response.use(undefined, (err) => {
    //   console.log('dasdasd ', err);
      
    //   if (err.response.status === 401) {
    //     console.log('dasd');
        
    //     // this.errorMessage = err.response.message;
    //     router.push({ name: "Login" }).catch(() => { // 
    //     });
    //   }
    // });
  }

  @Mutation
  resetStore() {
    localStorage.setItem("sessionId", "");
    this.sessionId = "";
    this.locks = [];
    this.persons = [];
    this.keys = [];
    this.zones = [];
  }

  @Mutation
  setSessionId(sessionId: string) {
    localStorage.setItem("sessionId", sessionId);
    this.sessionId = sessionId;
  }

  @Mutation
  setLocks(locks: Lock[]) {
    this.locks = locks;
  }

  @Mutation
  setErrormessage(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      if(this.errorMessage === message) {
        this.errorMessage = null;
      }
    }, 7000)
    
  }

  @Mutation
  setPersons(persons: Person[]) {
    this.persons = persons;
  }

  @Mutation
  setKeys(keys: Key[]) {
    this.keys = keys;
  }

  @Mutation
  setZones(zones: Zone[]) {
    this.zones = zones;
  }

  @Action
  async createSession({
    userName,
    password,
    customerCode
  }: {
    userName: string;
    password: string;
    customerCode: string;
  }) {
    const data: CreateSessionParam = {
      UserName: userName,
      Password: password,
      CustomerCode: customerCode
    };

    const authApi = new AuthenticationApi({}, this.apiAddress, this.axiosInstance!);
    return authApi
      .authenticationCreateSession(data)
      .then((response: AxiosResponse<CreateSessionResult>) => {
        console.log('CreateSessionResult');
        
        if (response.data.SessionID) {
          this.setSessionId(response.data.SessionID);
          return this.getLockGroup();
        }
      });
  }

  @Action
  async getLockGroup() {
    const lock = new LockGroupsApi({}, this.apiAddress);
    return lock
      .lockGroupsGetAllLockGroups(this.headerConfig)
      .then((value: AxiosResponse<LockGroup[]>) => {
        console.log('GetLockGroup');
        
        const locksGroups = value.data;
        return this.setLockGroup(locksGroups[0].LockGroup_ID!);
      });
  }

  @Action
  async setLockGroup(lockGroupId: string) {
    const data: SetLockgroupParam = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      LockGroup_ID: lockGroupId
    };
    const authApi = new AuthenticationApi({}, this.apiAddress);
    return authApi
      .authenticationSetLockgroup(data, this.headerConfig)
      .then(response => {
        console.log('group set');
        
        // router.push({ name: "Locks" })
        // this.fetchLocks();
        return;
      });
  }

  @Action
  async fetchLocks() {
    const api = new LocksApi({}, this.apiAddress, this.axiosInstance!);
    api.locksGetAllLocks(this.headerConfig).then(response => {
      console.log(response);
      
      const locks: Lock[] = response.data;
      this.setLocks(locks);
    }).catch((error) => {
      console.log(error);
      
    });
  }

  @Action
  async fetchLockLog(fLockId: string) {
    const locks = { FLockIds: [fLockId] };
    const api = new LockLogsApi({}, this.apiAddress);
    return api
      .lockLogsGetLockLogs(locks, this.headerConfig)
      .then((value: AxiosResponse<GetLockLogsResult>) => {
        const result: GetLockLogsResult = value.data;
        return result;
      });
  }

  @Action
  async fetchPersons() {
    const api = new PersonsApi({}, this.apiAddress);
    return api
      .personsGetAllPersons(this.headerConfig)
      .then((value: AxiosResponse<Person[]>) => {
        const result: Person[] = value.data;
        this.setPersons(result)
        return result;
      });
  }

  @Action
  async createPerson({ person, zoneId }:{ person: PersonInsert, zoneId: string }) {
    const api = new PersonsApi({}, this.apiAddress);
    const insert: InsertPersonParam = {
      Person: person,
      ZoneIds: [ zoneId ]
    }
    return api
      .personsInsert(insert, this.headerConfig)
      .then((value: AxiosResponse<InsertResult>) => {
        const result: InsertResult = value.data;
        this.fetchPersons();
        return result;
      });
  }

  @Action
  async fetchKeys() {
    const api = new KeysApi({}, this.apiAddress);
    return api
      .keysGetAllKeys(this.headerConfig)
      .then((value: AxiosResponse<Key[]>) => {
        const result: Key[] = value.data;
        this.setKeys(result)
        return result;
      }).catch(ero => {
        this.setErrormessage(ero.response.data.Message)
      });
  }

  @Action
  async fetchZones() {
    const api = new ZonesApi({}, this.apiAddress);
    return api
      .zonesGetAllZones(this.headerConfig)
      .then((value: AxiosResponse<Zone[]>) => {
        const result: Zone[] = value.data;
        this.setZones(result)
        return result;
      });
  }

  @Action
  async logout() {
    const api = new AuthenticationApi({}, this.apiAddress, this.axiosInstance!);
    return api
      .authenticationKillSession(this.headerConfig).finally(() => {
        this.resetStore();
        router.push({ name: "Login" })
      })
  }
}

export const lockModule = getModule(LockStore, store);
